var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var NativeAdsAdapter = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-THEOplayer2-ads'
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.currentTime
  },

  getTitle: function () {
    return 'unknown'
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.player.ads.currentAdBreak) {
      return this.player.ads.currentAdBreak.ads[this.adCount - 1].duration
    }
    return this.player.duration
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (this.player.ads.currentAdBreak) {
      return this.player.ads.currentAdBreak.ads[this.adCount - 1].mediaFiles[0].resourceURI
    }
    return null
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    if (!this.plugin.getAdapter().flags.isJoined) {
      return youbora.Constants.AdPosition.Preroll
    }
    if (this.plugin.getAdapter().getDuration() &&
            (this.plugin.getAdapter().getPlayhead() + (this.plugin._ping.interval / 1000) > this.plugin.getAdapter().getDuration())) {
      return youbora.Constants.AdPosition.Postroll
    }
    return youbora.Constants.AdPosition.Midroll
  },

  getGivenBreaks: function () {
    if (this.player.ads.scheduledAdBreaks) {
      return this.player.ads.scheduledAdBreaks.length
    }
    return null
  },

  getExpectedBreaks: function () {
    if (this.player.ads.scheduledAdBreaks) {
      var adbreaks = this.player.ads.scheduledAdBreaks
      var pre = 0
      var mid = 0
      var post = 0
      for (var adbreakindex in adbreaks) {
        var adbreak = adbreaks[adbreakindex]
        if (adbreak.timeOffset === 0) {
          pre++
        } else if (adbreak.timeOffset === -1) {
          post++
        } else {
          mid++
        }
      }
      return {
        pre,
        mid,
        post
      }
    }
    return null
  },

  getGivenAds: function () {
    if (this.actualSlot) {
      return this.actualSlot.ads.length
    }
    return null
  },

  /* getBreaksTime: function() {
              var adbreaks = this.player.ads.scheduledAdBreaks
              var timelist = []
              for (adbreakindex in adbreaks) {
                  var value = adbreaks[adbreakindex].timeOffset
                  if (value === -1) {
                      timelist.push(this.plugin.getAdapter().getDuration())
                  } else {
                      timelist.push(value)
                  }
              }
              return timelist
              // Midroll time can be NaN and postrolls -1 when content duration is not available yet,
              //so this method would be not reliable
          }, */

  getIsVisible: function () {
    return youbora.Util.calculateAdViewability(this.player.element)
  },

  getAudioEnabled: function () {
    return !this.player.muted && this.player.volume > 0
  },

  getIsSkippable: function () {
    if (this.player.ads && this.player.ads.currentAds && this.player.ads.currentAds[0]) {
      return !!this.player.ads.currentAds[0].skipOffset
    }
    return false
  },

  getIsFullscreen: function () {
    if (this.player.element && this.player.element.clientWidth && this.player.element.clientHeight) {
      return (window.innerHeight <= this.player.element.clientHeight + 30 && window.innerWidth <= this.player.element.clientWidth + 30)
    }
    return false
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player.ads)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.references = []
    this.references['adbegin'] = this.playAdListener.bind(this)
    this.references['adend'] = this.endedAdListener.bind(this)
    this.references['aderror'] = this.errorAdListener.bind(this)
    this.references['adskip'] = this.skipAdListener.bind(this)
    this.references['adbreakbegin'] = this.breakBeginListener.bind(this)
    this.references['adbreakend'] = this.breakEndListener.bind(this)
    this.playerReferences = []
    this.playerReferences['pause'] = this.pauseAdListener.bind(this)
    this.playerReferences['playing'] = this.resumeAdListener.bind(this)
    this.playerReferences['play'] = this.resumeAdListener.bind(this)
    this.playerReferences['timeupdate'] = this.quartileListener.bind(this)

    for (var key in this.references) {
      this.player.ads.addEventListener(key, this.references[key])
    }

    for (var key2 in this.playerReferences) {
      this.player.addEventListener(key2, this.playerReferences[key2])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.player.ads && this.references) {
      for (var key in this.references) {
        this.player.ads.removeEventListener(key, this.references[key])
      }
      this.references = []
    }

    if (this.player && this.playerReferences) {
      for (var key2 in this.playerReferences) {
        this.player.removeEventListener(key2, this.playerReferences[key2])
      }
      this.playerReferences = []
    }
  },

  /** Listener for 'adbegin' event. */
  playAdListener: function (e) {
    this.adCount += 1
    this.plugin._adapter.fireInit()
    this.fireStart()
    this.fireJoin()
    this.duration = this.getDuration()
    this.firstQuartileTriggered = false
    this.secondQuartileTriggered = false
    this.thirdQuartileTriggered = false
  },

  /** Listener for 'aderror' event. */
  errorAdListener: function (e) {
    this.fireError()
  },

  /** Listener for 'adend' event. */
  endedAdListener: function (e) {
    this.fireStop({
      adPlayhead: this.duration
    })
  },

  /** Listener for 'adskip' event. */
  skipAdListener: function (e) {
    this.fireStop({
      skipped: true
    })
  },

  pauseAdListener: function (e) {
    this.firePause()
  },

  resumeAdListener: function (e) {
    this.fireResume()
  },

  breakBeginListener: function (e) {
    this.adCount = 0
    this.actualSlot = e.ad
  },

  breakEndListener: function (e) {
    this.fireBreakStop()
  },

  quartileListener: function (e) {
    if (this.getPlayhead() > this.getDuration() / 4) {
      if (!this.firstQuartileTriggered) {
        this.fireQuartile(1)
        this.firstQuartileTriggered = true
      } else if (this.getPlayhead() > this.getDuration() / 2) {
        if (!this.secondQuartileTriggered) {
          this.fireQuartile(2)
          this.secondQuartileTriggered = true
        } else if (this.getPlayhead() > this.getDuration() * 0.75) {
          if (!this.thirdQuartileTriggered) {
            this.fireQuartile(3)
            this.thirdQuartileTriggered = true
          }
        }
      }
    }
  }
})

module.exports = NativeAdsAdapter
